import { useMemo } from 'react';
import { SettingsWorkspace } from '@reach/settings-workspace';
import { LegalConsentShield } from '../components/LegalConsentShield';

export function DashboardCompat() {
  const shopDomain = useMemo(() => {
    const params = new URLSearchParams(window.location.search);
    return params.get('shop') || params.get('domain') || 'localhost';
  }, []);

  return (
    <>
      <LegalConsentShield shopDomain={shopDomain} />
      <SettingsWorkspace
        shopDomain={shopDomain}
        layoutVariant="dashboard"
        showOnboarding
      />
    </>
  );
}
